if (import.meta.hot) {
    import.meta.hot.on('vite:beforeFullReload', () => {
        if (window.location.pathname.startsWith('/admin')) {
            const orig = location.reload.bind(location);
            location.reload = () => { location.reload = orig; };
        }
    });
}

import Alpine from 'alpinejs';
import 'fslightbox';
import './bootstrap.js';
import './freibad-counter.js';
import { registerSearchSpotlight } from './search-spotlight.js';
import { initYoutubeConsent } from './youtube-consent.js';

window.Alpine = Alpine;
registerSearchSpotlight(Alpine);
Alpine.start();

// Klaro-gated YouTube embeds (video / video-dual bricks).
initYoutubeConsent();

// Portal News Slider
document.addEventListener('DOMContentLoaded', function () {
    const slider = document.getElementById('sliderInner');
    if (!slider) return;

    // Alle Prev-Buttons erfassen
    const allPrevButtons = document.querySelectorAll('#prevButton');

    // Alle Next-Buttons erfassen
    const allNextButtons = document.querySelectorAll('#nextButton');

    const slides = slider.children;
    let currentIndex = 0;
    let autoScrollInterval;

    function updateSlider() {
        const offset = -currentIndex * 100;
        slider.style.transform = `translateX(${offset}%)`;
    }

    function showNextSlide() {
        currentIndex = (currentIndex + 1) % slides.length;
        updateSlider();
    }

    function showPrevSlide() {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        updateSlider();
    }

    function startAutoScroll() {
        // Stellt sicher, dass kein Intervall bereits läuft
        stopAutoScroll();
        autoScrollInterval = setInterval(showNextSlide, 5000);
    }

    function stopAutoScroll() {
        if (autoScrollInterval) {
            clearInterval(autoScrollInterval);
            autoScrollInterval = null;
        }
    }

    // Event-Listeners für ALLE Next-Buttons hinzufügen
    allNextButtons.forEach(button => {
        button.addEventListener('click', function () {
            showNextSlide();
            // Optionale Erweiterung: Auto-Scroll bei manuellem Klick stoppen
            // und nach einer kurzen Verzögerung wieder starten
            stopAutoScroll();
            setTimeout(startAutoScroll, 10000); // 10 Sekunden warten
        });
    });

    // Event-Listeners für ALLE Prev-Buttons hinzufügen
    allPrevButtons.forEach(button => {
        button.addEventListener('click', function () {
            showPrevSlide();
            // Optionale Erweiterung: Auto-Scroll bei manuellem Klick stoppen
            // und nach einer kurzen Verzögerung wieder starten
            stopAutoScroll();
            setTimeout(startAutoScroll, 10000); // 10 Sekunden warten
        });
    });

    // Hover-Ereignisse hinzufügen
    slider.addEventListener('mouseenter', stopAutoScroll);
    slider.addEventListener('mouseleave', startAutoScroll);

    // Initialisierung
    updateSlider();
    startAutoScroll();
});

// Portal News - Simple fade-in animation
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.news-item').forEach((item, index) => {
        setTimeout(() => {
            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';
        }, 100 * index);
    });
});

// Portal Event Slider
document.addEventListener('DOMContentLoaded', function () {
    // Warten bis alle DOM-Elemente vollständig geladen sind
    setTimeout(() => {
        // Hauptelemente des Sliders
        const slider = document.getElementById('eventSlider');

        // Alle Prev-Buttons (Desktop und Mobile)
        const allPrevButtons = document.querySelectorAll('#eventPrevButton');

        // Alle Next-Buttons (Desktop und Mobile)
        const allNextButtons = document.querySelectorAll('#eventNextButton');

        // Prüfen, ob grundlegende Elemente existieren
        if (!slider) {
            return; // Exit if slider doesn't exist on this page
        }

        const items = slider.children;

        let currentIndex = 0;

        // Konfiguration basierend auf Bildschirmgröße
        function getConfig() {
            // Standardwerte für größere Bildschirme
            let visibleItems = 3;
            let slideWidth = items[0].offsetWidth;

            // Anpassungen für verschiedene Bildschirmgrößen
            if (window.innerWidth < 768) {
                // Mobile: Volle Breite, 1 Element
                visibleItems = 1;
                slideWidth = slider.offsetWidth;
            } else if (window.innerWidth < 1024) {
                // Tablet: 2 Elemente
                visibleItems = 2;
            }

            return {visibleItems, slideWidth};
        }

        // Slider-Position aktualisieren und Button-Status setzen
        function updateSlider() {
            const {slideWidth, visibleItems} = getConfig();
            slider.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

            // Button-Status aktualisieren
            updateButtonStates(visibleItems);
        }

        // Buttons basierend auf aktueller Position aktivieren/deaktivieren
        function updateButtonStates(visibleItems) {
            // Prev-Buttons ausgrauen, wenn wir am Anfang sind
            const isPrevDisabled = currentIndex === 0;
            allPrevButtons.forEach(button => {
                button.style.opacity = isPrevDisabled ? '0.5' : '1';
                button.style.cursor = isPrevDisabled ? 'default' : 'pointer';

                // SVG-Element innerhalb des Buttons finden (für Hover-Effekt)
                const svg = button.querySelector('svg');
                if (svg) {
                    // Hover-Klasse entfernen/hinzufügen
                    if (isPrevDisabled) {
                        svg.classList.remove('hover:bg-orange');
                        svg.classList.add('no-hover');
                    } else {
                        svg.classList.add('hover:bg-orange');
                        svg.classList.remove('no-hover');
                    }
                }
            });

            // Next-Buttons ausgrauen, wenn wir am Ende sind
            const isNextDisabled = currentIndex >= items.length - visibleItems;
            allNextButtons.forEach(button => {
                button.style.opacity = isNextDisabled ? '0.5' : '1';
                button.style.cursor = isNextDisabled ? 'default' : 'pointer';

                // SVG-Element innerhalb des Buttons finden (für Hover-Effekt)
                const svg = button.querySelector('svg');
                if (svg) {
                    // Hover-Klasse entfernen/hinzufügen
                    if (isNextDisabled) {
                        svg.classList.remove('hover:bg-orange');
                        svg.classList.add('no-hover');
                    } else {
                        svg.classList.add('hover:bg-orange');
                        svg.classList.remove('no-hover');
                    }
                }
            });
        }

        // Event-Listeners für ALLE Prev-Buttons hinzufügen (Desktop und Mobile)
        allPrevButtons.forEach(button => {
            button.addEventListener('click', function () {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateSlider();
                }
            });
        });

        // Event-Listeners für ALLE Next-Buttons hinzufügen (Desktop und Mobile)
        allNextButtons.forEach(button => {
            button.addEventListener('click', function () {
                const {visibleItems} = getConfig();
                if (currentIndex < items.length - visibleItems) {
                    currentIndex++;
                    updateSlider();
                }
            });
        });

        // Bei Fenstergröße-Änderung Slider aktualisieren
        window.addEventListener('resize', function () {
            // Bei Größenänderung auf erstes Element zurücksetzen
            currentIndex = 0;
            updateSlider();
        });

        // Initial Slider einrichten
        updateSlider();

    }, 200); // Verzögerung, um sicherzustellen, dass alle Elemente geladen sind
});


// Portal Hotspot Funktion
document.addEventListener('DOMContentLoaded', (event) => {
    const hotspots = document.querySelectorAll('.image-hotspot');

    hotspots.forEach(hotspot => {
        const tooltip = hotspot.querySelector('[role="tooltip"]');
        if (!tooltip) return;

        hotspot.addEventListener('mouseenter', () => {
            tooltip.classList.remove('hidden');
            positionTooltip(hotspot, tooltip);
        });

        hotspot.addEventListener('mouseleave', () => {
            tooltip.classList.add('hidden');
        });
    });

    function positionTooltip(hotspot, tooltip) {
        const hotspotRect = hotspot.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();

        let top = hotspotRect.top - tooltipRect.height;

        // Hier fügen wir einen Offset für die horizontale Position hinzu
        // Anstatt das Tooltip zu zentrieren, verschieben wir es nach rechts
        // Sie können den Wert 50 anpassen, um die gewünschte Position zu erreichen
        let left = hotspotRect.left + (hotspotRect.width / 2) - (tooltipRect.width / 2) + 50;

        // Überprüfen und anpassen, wenn der Tooltip über den Bildschirmrand hinausragt
        if (top < 0) top = hotspotRect.bottom;
        if (left < 0) left = 0;
        if (left + tooltipRect.width > window.innerWidth) left = window.innerWidth - tooltipRect.width;

        tooltip.style.top = `${top}px`;
        tooltip.style.left = `${left}px`;
    }
});

// Navmenu Toggle
document.addEventListener('DOMContentLoaded', function () {
    const submenuContainer = document.getElementById('submenuContainer');
    if (!submenuContainer) return;

    const submenus = submenuContainer.querySelectorAll('.submenu');
    const menuItems = document.querySelectorAll('[data-submenu-id]');
    const mainMenuItems = document.querySelectorAll('.group');

    // Globale Variable, um den aktuellen Zustand zu speichern
    let currentActiveSubmenu = null;

    // Die Funktion, die beim Hovern über einen Hauptmenüpunkt ausgelöst wird
    function activateFirstSubmenu(mainMenuItem) {
        // Finde den ersten Child-Menüpunkt dieses Hauptmenüpunkts
        const firstChildItem = mainMenuItem.querySelector('[data-submenu-id]');
        if (firstChildItem) {
            const submenuId = firstChildItem.dataset.submenuId;

            // Aktiviere das entsprechende Submenu
            submenus.forEach(submenu => {
                if (submenu.dataset.submenuId === submenuId) {
                    submenu.classList.add('opacity-100', 'z-10');
                    submenu.classList.remove('opacity-0');
                    // Speichere das aktive Submenu
                    currentActiveSubmenu = submenu;
                } else {
                    submenu.classList.remove('opacity-100', 'z-10');
                    submenu.classList.add('opacity-0');
                }
            });

            // Visuell den ersten Child-Menüpunkt hervorheben
            menuItems.forEach(item => {
                item.classList.remove('active-submenu');
            });
            firstChildItem.classList.add('active-submenu');
        }
    }

    // Event-Listener für Hauptmenüpunkte
    mainMenuItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            // Sofort das erste Untermenü aktivieren, ohne Verzögerung
            activateFirstSubmenu(this);
        });
    });

    // Event-Listener für die Submenüpunkte
    menuItems.forEach(item => {
        item.addEventListener('mouseenter', function () {
            const submenuId = this.dataset.submenuId;

            submenus.forEach(submenu => {
                if (submenu.dataset.submenuId === submenuId) {
                    submenu.classList.add('opacity-100', 'z-10');
                    submenu.classList.remove('opacity-0');
                    // Speichere das aktive Submenu
                    currentActiveSubmenu = submenu;
                } else {
                    submenu.classList.remove('opacity-100', 'z-10');
                    submenu.classList.add('opacity-0');
                }
            });

            // Visuelles Feedback für den aktiven Submenüpunkt
            menuItems.forEach(menuItem => {
                menuItem.classList.remove('active-submenu');
            });
            this.classList.add('active-submenu');
        });

        // Optional: Füge auch mouseleave-Event hinzu, der das Submenu jedoch nicht schließt
        item.addEventListener('mouseleave', function () {
            // Das Submenu bleibt geöffnet, auch wenn der Mauszeiger das Element verlässt
            // Wir stellen sicher, dass das currentActiveSubmenu weiterhin sichtbar bleibt
            if (currentActiveSubmenu) {
                currentActiveSubmenu.classList.add('opacity-100', 'z-10');
                currentActiveSubmenu.classList.remove('opacity-0');
            }
        });
    });

    // Wir entfernen den mouseleave-Event komplett, um das Menü offen zu halten
    // Stattdessen bleibt das Menü immer offen, bis ein anderer Hauptmenüpunkt gehovert wird

    // Stellen Sie sicher, dass initial das erste Submenu des ersten Hauptmenüpunkts sichtbar ist
    if (mainMenuItems.length > 0) {
        activateFirstSubmenu(mainMenuItems[0]);
    }
});
